import { render, staticRenderFns } from "./BusinessOverview.vue?vue&type=template&id=e2024d06&scoped=true"
import script from "./BusinessOverview.vue?vue&type=script&lang=js"
export * from "./BusinessOverview.vue?vue&type=script&lang=js"
import style0 from "./BusinessOverview.vue?vue&type=style&index=0&id=e2024d06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2024d06",
  null
  
)

export default component.exports